import { YYYY_MM_DD } from 'aegion_common_utilities/lib/format/datetime';
import { getDateRangeTypeMeta } from './util/DateRangeTypes';

const OLDER_THAN_15_MONTHS_META = getDateRangeTypeMeta('OLDER_THAN_15_MONTHS');

const stringifyDate = date => {
	if (date instanceof Date) {
		return YYYY_MM_DD(date);
	}
	return date;
};

const initialState = {
	type: OLDER_THAN_15_MONTHS_META.key,
	from: stringifyDate(OLDER_THAN_15_MONTHS_META.computeNewFrom()),
	to: stringifyDate(OLDER_THAN_15_MONTHS_META.computeNewTo()),
	enabled: false,
	historical: false
};

export default initialState;
